import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { Subscription } from 'rxjs';
import { AuthService, encryptStorage } from 'src/app/auth/auth.service';
import { NzTableData } from 'src/app/utilities/nz-table.adapter';
import { OrdersSearch } from 'src/app/models/orders';
import { DateRange, MomentHelper } from '../../models/date';
import { OrdersService } from '../orders.service';
import { emptyFields, MerchantOrderStatusOptions, OrdersMobOptions, ReportTerminals, TopupOptions, UsersType} from 'src/app//utilities/common-file';
import { CommonService } from 'src/app/utilities/common-service';
import { OrderLogsComponent } from '../order-logs/order-logs.component';
import { EditOrdersComponent } from './edit-orders/edit-orders.component';
import { ViewOrdersComponent } from 'src/app/view-details/view-orders.component';
import { OrdersDrawerComponent } from './orders-drawer/orders-drawer.component';
import { ReceiptOrderDetailsComponent } from './receipt-order-details/receipt-order-details.component';
import { GenerateOrderReceiptComponent } from './generate-order-receipt/generate-order-receipt.component';
import * as moment from 'moment';
import { Messages } from 'src/app/utilities/message';
import { DownloadService } from 'src/app/reports/download-service';


@Component({
  selector: 'app-all-orders',
  templateUrl: './all-orders.component.html',
})
export class AllOrdersComponent implements OnInit {

  private tableData: NzTableData<OrdersSearch, any> = new NzTableData <OrdersSearch, any>(new OrdersSearch(), 'name');

loading: boolean;
subscription: Subscription;
// For drawer Close when refresh custom token fails
showDownload: string;
notifyLogout: any;
emptyField = emptyFields;
prevValue: string;
selectedOrders: any;
selectedIdDetails: any;
currencySymbol='';
loginUserType = '';
downloadList = [];
mobileOptions=OrdersMobOptions;
userType = UsersType;
orderStatusOptions = MerchantOrderStatusOptions;
locationsList = [];
selectedRateDateRange: Date[] = null;
constructor(private modal: NzModalService, private drawerService: NzDrawerService, private notification: NzNotificationService, private ordersService: OrdersService, private authService: AuthService,private commonService:CommonService, private router:Router,private downloadService:DownloadService) {

}

ngOnInit() {
  this.currencySymbol = encryptStorage.getItem('currencySymbol');
  this.loginUserType = this.authService.getRole();
  this.getLocations();
  this.refresh();  
}


// For List
refresh(startFromPageOne: boolean = true): void {
  this.loading = true;
  this.tableData.data = [];
  if (startFromPageOne) {
    this.tableData.pageIndex = 1;
  }
  console.log(this.tableData);
  this.tableData.search.appCode=this.authService.getAppCode();
  this.ordersService.getMerchantOrderLogs(this.tableData).subscribe((response: any) => {
     this.loading = false;
    this.tableData.total = response.data.total;
    if (response.data && response.data.merchantOrders) {
      this.tableData.data = response.data.merchantOrders;
      this.showDownload = Messages.downloadReport;

    } else {
      this.tableData.data = [];
      this.showDownload = '';
    }
  }, (err) => {
    this.loading = false;
    this.tableData.data = [];
    this.showDownload = '';
  });
}
 // For changing date range
 onUpdatedOnChange(range: any[]) {
  if (range.length <= 1) {
    return;
  }
  this.tableData.search.createdDate = MomentHelper.createDateRange(range);
  this.refresh();
}
modelChanged(value) {
  if (this.prevValue == 'display_name') {
    this.clearSearch('displayName');
  }
  else {
    this.clearSearch('number');
  }
  this.prevValue = value;
}
// For date range reset
updateClear(range: any[]) {
  if (range.length <= 1) {
    this.tableData.search.createdDate = DateRange.empty();
    return;
}
}

// For Page index change
onIndexChange(event) {
  this.tableData.pageIndex = event;
  this.refresh(false);
}

// viewLogs(row) {
//   this.router.navigate(['/orders/order-logs/' + row.id]);
// }
  // To View KYC History timeline
  viewLogs(data) {
    this.selectedOrders = data
    const drawerRefCreate = this.drawerService.create<OrderLogsComponent, { selectedUserId: any }, string>({
      nzContent: OrderLogsComponent,
      nzTitle: 'Orders Logs'+ "/" + 'Order No:' + ' ' + data.orderNumber ,
      nzWidth: '500px',
      nzClosable: true,
      nzContentParams: {
        selectedUserId: this.selectedOrders
      },
      nzBodyStyle: {
        height: 'calc(100% - 55px)',
        overflow: 'auto'
      }
    });
    // tslint:disable-next-line: no-shadowed-variable
    drawerRefCreate.afterClose.subscribe((data) => {
      if (data && typeof data !== null) {
      }
    });
  }


editOrders(data) {
  this.selectedOrders = data;
  const drawerRefEdit = this.drawerService.create<OrdersDrawerComponent, { selectedOrders: string }, string>({
    nzTitle: 'Order No:' + ' ' + data.orderNumber,
    nzContent: OrdersDrawerComponent,
    nzWidth: '860px',
    nzClosable: true,
    nzContentParams: {
      selectedOrders: this.selectedOrders
    },
    nzBodyStyle: {
      height: 'calc(100% - 55px)',
      overflow: 'auto'
    }
  });
  // For drawer Close when refresh custom token fails
  drawerRefEdit.afterOpen.subscribe(() => {
    this.notifyLogout = this.authService.notify.subscribe((result) => {
      if (result) {
        drawerRefEdit.close();
      }
    });
  });
  drawerRefEdit.afterClose.subscribe(data => {
    if (data && typeof data !== null) {
      this.refresh();
    }
  });
}
viewOrders(data) {
  const drawerRefCreate = this.drawerService.create<ViewOrdersComponent, { selectedOrders: any},
  any>({
    nzTitle: 'Order No:' + ' ' + data.orderNumber,
    nzContent: ViewOrdersComponent,
    nzWidth: '860px',
    nzClosable: true,
    nzContentParams: {
     selectedOrders: data
    },
    nzBodyStyle: {
      height: 'calc(100% - 55px)',
      overflow: 'auto'
    }
  });
   //  For drawer Close when refresh custom token fails
   drawerRefCreate.afterOpen.subscribe(() => {
    this.notifyLogout = this.authService.notify.subscribe((result) => {
      if (result) {
        drawerRefCreate.close();
      }
  });
  });
  drawerRefCreate.afterClose.subscribe((data) => {
   if (data && typeof data !== null) {
   }
  });
}
viewOrdersRecieptList(data) {
  const drawerRefCreate = this.drawerService.create<ReceiptOrderDetailsComponent, { selectedOrders: any},
  any>({
    nzTitle: 'Order No:' + ' ' + data.orderNumber,
    nzContent: ReceiptOrderDetailsComponent,
    nzWidth: '860px',
    nzClosable: true,
    nzContentParams: {
     selectedOrders: data
    },
    nzBodyStyle: {
      height: 'calc(100% - 55px)',
      overflow: 'auto'
    }
  });
   //  For drawer Close when refresh custom token fails
   drawerRefCreate.afterOpen.subscribe(() => {
    this.notifyLogout = this.authService.notify.subscribe((result) => {
      if (result) {
        drawerRefCreate.close();
      }
  });
  });
  drawerRefCreate.afterClose.subscribe((data) => {
   if (data && typeof data !== null) {
   }
  });
}
printReceipt(data){
  const drawerRefCreate = this.drawerService.create<GenerateOrderReceiptComponent, { selectedOrders: any},
  any>({
    nzTitle: 'Order No:' + ' ' + data.orderNumber,
    nzContent: GenerateOrderReceiptComponent,
    nzWidth: '860px',
    nzClosable: true,
    nzContentParams: {
     selectedOrders: data
    },
    nzBodyStyle: {
      height: 'calc(100% - 55px)',
      overflow: 'auto'
    }
  });
   //  For drawer Close when refresh custom token fails
   drawerRefCreate.afterOpen.subscribe(() => {
    this.notifyLogout = this.authService.notify.subscribe((result) => {
      if (result) {
        drawerRefCreate.close();
      }
  });
  });
  drawerRefCreate.afterClose.subscribe((data) => {
   if (data && typeof data !== null) {
   }
  });
}
getLocations() {
  this.locationsList = this.authService.getLocationDetails();
   this.tableData.search.locationId = this.locationsList[0].id;
}
  // To Show Status
  getStatus(status) {
    return this.commonService.getOrderStatus(status);
  }
  // For User Status Tag color
  getStatusColor(status) {
    return this.commonService.getOrderStatusColor(status);
  }
  getCurrency(currency) {
    return this.commonService.getCurrency(currency);
  }
    // To clear search fields
    clearSearch(value) {
      return this.ordersService.clearSearchFields(this.tableData, value);
    }
 // For Download Excel
 downloadReport() {
  if (this.tableData.search.createdDate.startDate && this.tableData.search.createdDate.endDate) {
  this.notification.info('Download Processing', 'Please Wait', {
    nzKey: 'key'
  });
  const value = {
    id: this.tableData.search.id,
    orderStatus: this.tableData.search.orderStatus,
    startDate: this.tableData.search.createdDate.startDate ? this.tableData.search.createdDate.startDate : '',
    endDate: this.tableData.search.createdDate.endDate ? this.tableData.search.createdDate.endDate : '',
    appCode: this.tableData.search.appCode,
    merchantLocationId:this.tableData.search.locationId ,
    mobileNo: this.tableData.search.type === 'mobile_no' ? (this.tableData.search.number ? this.tableData.search.number.toString() : '') : '',
    accountNo: this.tableData.search.type === 'account_no' ? this.tableData.search.number : '',
    displayName: this.tableData.search.type === 'display_name' ? this.tableData.search.displayName : '',
    orderCreatedFrom:this.tableData.search.orderCreatedFrom,
    orderNumber:this.tableData.search.orderNumber,
  };
  // For filter headers
  const filterHeaders = ['Created On', 'Location Name',this.tableData.search.type === 'mobile_no' ? 'Mobile Number' :
  this.tableData.search.type === 'account_no' ? 'Account Number' : 
  this.tableData.search.type === 'display_name' ? 'Display Name' : '','Order Number','Order Status'];
    const filterData = [this.tableData.search.createdDate ? moment(this.tableData.search.createdDate.startDate)
  .local().format('DD-MMM-YYYY') + ' to ' + moment(this.tableData.search.createdDate.endDate).local().format('DD-MMM-YYYY') : '',
  this.tableData.search.locationId ? this.locationsList.find(x => x.id === this.tableData.search.locationId).name : 'All',
  this.tableData.search.type === 'mobile_no' ? (this.tableData.search.number ? this.tableData.search.number.toString() : '') :
  this.tableData.search.type === 'account_no' ? this.tableData.search.number : 
  this.tableData.search.type === 'display_name' ? this.tableData.search.displayName : '',
  this.tableData.search.orderNumber ? this.tableData.search.orderNumber : '',
  this.tableData.search.orderStatus ? this.getStatus(this.tableData.search.orderStatus) : ''
  ];
  // API request
  this.ordersService.downloadMerchantOrderLogsDetails(value).subscribe((response: any) => {
     this.downloadList = response.data.merchantOrders;
    if (this.downloadList.length > 0) {
       const headers = ['ID','Order Number','Account Number','Mobile Number','Display Name','Location Name','Total Quantity','Total Price','Tax Amount','Discount Amount','Net Amount','Order Status','Created Date','Created By', 'Updated Date', 'Updated By'];

      this.downloadService.onDownloadExcel(headers, ReportTerminals.merchantOrderDetails, this.tableData.search.createdDate.startDate,
        this.tableData.search.createdDate.endDate, this.downloadList, ReportTerminals.merchantOrderDetails,
        ReportTerminals.merchantOrderDetails, filterHeaders, filterData);
    }
  });
}else{
  this.notification.error(Messages.noDateSelected, '', {
    nzKey : 'key'
  });
}
}
}

